import { SourceUsageDomainType } from "../types";

export type UsageDomainClass =
  | "is-domain-news"
  | "is-domain-social"
  | "is-domain-forum"
  | "is-domain-other";

const DOMAIN_TYPE_TO_CLASS: Record<SourceUsageDomainType, UsageDomainClass> = {
  news: "is-domain-news",
  social: "is-domain-social",
  forum: "is-domain-forum",
  other: "is-domain-other",
};

/**
 * Returns BEM modifier class for Usage cell based on domain type.
 */
export function getUsageColorByDomainType(
  domainType: SourceUsageDomainType
): UsageDomainClass {
  return DOMAIN_TYPE_TO_CLASS[domainType];
}
